<template>
  <div class="app-container">
    <el-card>
      <el-divider
        direction="horizontal"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff', padding: '0 5px' }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          基本信息
        </h3>
      </el-divider>
      <el-form
        ref="formRef"
        class="mt25"
        :model="formData"
        inline
        label-position="top"
      >
        <el-form-item label="选择入库申请单">
          <el-button type="primary" @click="chooseApplication"
            >申请单</el-button
          >
          <!-- <el-input disabled v-model="formData.name" style="width: 240px" /> -->
        </el-form-item>
        <el-form-item label="入库单名称">
          <el-input disabled v-model="formData.name" style="width: 240px" />
        </el-form-item>
        <el-form-item label="入库仓库">
          <el-select
            v-model="formData.inWarehouse"
            filterable
            clearable
            disabled
            placeholder="请选择入库仓库"
            style="width: 240px"
          >
            <el-option
              v-for="subItem in warehouseList"
              :key="subItem.warehouseId"
              :label="subItem.warehouseName"
              :value="subItem.warehouseId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="出库仓库">
          <el-select
            v-model="formData.outWarehouse"
            filterable
            clearable
            disabled
            placeholder="请选择出库仓库"
            style="width: 240px"
          >
            <el-option
              v-for="subItem in warehouseList"
              :key="subItem.warehouseId"
              :label="subItem.warehouseName"
              :value="subItem.warehouseId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input
            disabled
            v-model="formData.trackingNumber"
            style="width: 240px"
          />
        </el-form-item>
        <!-- <el-form-item label="退货地址">
          <el-input disabled v-model="formData.returnAddress" style="width: 240px" />
        </el-form-item> -->
        <el-form-item label="备注">
          <el-input disabled v-model="formData.remarks" style="width: 240px" />
        </el-form-item>
      </el-form>
      <el-divider
        direction="horizontal"
        :style="{
          color: '#1989fa',
          borderColor: '#d0e6ff',
          marginTop: '25px',
          padding: '0 5px',
        }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          产品信息
        </h3>
      </el-divider>
      <SelectProductTable
        class="mt25"
        ref="selectProductTableRef"
        :data="selectProductTableData"
        :showConnectPro="false"
        :showDelBtn="false"
        :showAddBtn="false"
        :changeProNum="false"
        :disabledDelAndAdd="disabledDelAndAdd"
        :warehouseId="formData.inWarehouse"
      />
      <el-divider
        direction="horizontal"
        border-style="dashed"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff' }"
      >
      </el-divider>
      <el-row :gutter="8" class="mt5">
        <el-col :span="1.5">
          <el-button
            type="primary"
            :disabled="saveIngFlag"
            @click="handleSubmit"
            >提交</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button :disabled="saveIngFlag" @click="handleSaveDraft"
            >保存草稿</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button :disabled="saveIngFlag" @click="handleImportDraft"
            >导入草稿</el-button
          >
        </el-col>
        <el-col :span="1.5">
          <el-button :disabled="saveIngFlag" @click="handleReset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <Dialog
      title="选择申请单"
      :modelValue="modelValue"
      width="60%"
      @onConfirm="handleConfirm"
      @onClosed="handleClosed"
    >
      <template #content>
        <Table
          :data="tableData"
          ref="tableRef"
          :columns="columns"
          maxHeight="500"
          :total="total"
          :loading="loading"
          :showFun="false"
          :isSelect="true"
          :isRadio="true"
          rowKey="applicationFormId"
          @onSearch="handleSearch"
        />
      </template>
    </Dialog>
    <ImportDraft
      v-model="draftDialogOpen"
      :searchData="{ status: '1', type: '2' }"
      :columns="importDraftColumns"
      @success="handleImportDraftSuccess"
    />
    <ErrDataDialog :data="errTableData" title="入库失败说明" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import useCacheStore from "@/store/modules/cache";
import SelectProductTable from "@/views/warehouse/components/SelectProductTable";
import ImportDraft from "@/views/warehouse/components/ImportDraft";
import {
  inputWarehouse,
  selectProductRecordsByApplicationFormId,
} from "@/api/warehouse/outInWarehouse";
import { getCustomTableCols } from "@/tableColumn";
import { isNull } from "@/utils/fangerUtils";
import { errorMsg } from "@/utils/msgBox";
import Dialog from "@/components/Element/Dialog";
import Table from "@/components/Element/Table";
import { listApplicationForm } from "@/api/warehouse/applicationForm";
const cacheStore = useCacheStore();
const warehouseList = cacheStore.superWarehouse;
const { getProductById, getWarehouseNameById } = cacheStore;
import ErrDataDialog from "@/views/warehouse/components/errDataDialog";

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "allocationInWarehouse",
});

const formRef = ref(null);
const selectProductTableRef = ref(null);
const selectProductTableData = ref([]);
const formData = ref({});
const modelValue = ref(false);
const tableData = ref([]);
const errTableData = ref([]);
const columns = getCustomTableCols([
  "name",
  "applicant",
  "applicationTime",
  "applicationFormType",
  "inWarehouseName",
]);
const total = ref(0);
const loading = ref(false);
const handleClosed = () => {
  modelValue.value = false;
};
const tableRef = ref(null);
const handleConfirm = () => {
  // 确认选择的申请单
  // emits("success", tableRef.value.getSelectedRows());
  const selectData = tableRef.value.getSelectedRows();
  getProductRecordsRows(selectData);
};

// 选择入库申请单
const chooseApplication = () => {
  modelValue.value = true;
  handleSearch({ pageIndex: 1, pageSize: 10 });
};

const handleSearch = (data) => {
  loading.value = true;
  listApplicationForm({
    ...data,
    approvalStatus: "1",
    status: "4",
    type: "2",
    outInStatus: "1",
  })
    .then((res) => {
      res.data?.forEach((item) => {
        item.inWarehouseName = getWarehouseNameById(item.inWarehouse);
      });
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch((res) => {})
    .finally(() => {
      loading.value = false;
    });
};

const getProductRecordsRows = (res) => {
  if (!res) return;
  formData.value = res;
  modelValue.value = false;
  // 根据id获取产品
  selectProductRecordsByApplicationFormId(
    formData.value.applicationFormId
  ).then((data) => {
    const arr = [];
    data.data.forEach((item) => {
      item.oriIncompleteNumber = item.incompleteNum;
      item.canChange = true;
      arr.push({
        ...getProductById(item.productId),
        ...item,
      });
    });
    disabledDelAndAdd.value = true;
    selectProductTableData.value = arr;
    handleClosed();
  });
};
// 正在保存中标志，防止鼠标误点多次提交
const saveIngFlag = ref(false);

// 提交
const handleSubmit = () => {
  formRef.value.validate((valid) => {
    // 不合规直接返回
    if (!valid) return;
    if (saveIngFlag.value) {
      return;
    }

    const productData = selectProductTableRef.value.getProductData();
    if (productData === null) return;
    // if (productData.length === 0) {
    //   errorMsg("请选择产品，最少选择一个产品");
    //   return;
    // }
    formData.value.jsonData = JSON.stringify(productData);
    saveIngFlag.value = true;
    inputWarehouse({
      ...formData.value,
      completionStatus: "1",
      type: "2",
    })
      .then((res) => {
        // 重置表单
        formData.value = {};
        formRef.value.resetFields();
        selectProductTableRef.value.clearProductData();
        saveIngFlag.value = false;
      })
      .catch((res) => {
        errTableData.value = res.data;
        saveIngFlag.value = false;
      })
      .finally(() => {
        saveIngFlag.value = false;
      });
  });
};
// 保存草稿
const handleSaveDraft = () => {
  formRef.value.validate((valid) => {
    // 不合规直接返回
    if (!valid) return;
    if (saveIngFlag.value) {
      return;
    }
    const productData = selectProductTableRef.value.getProductData(false);
    if (productData === null) return;
    formData.value.jsonData = JSON.stringify(productData);
    saveIngFlag.value = true;
    inputWarehouse({
      ...formData.value,
      completionStatus: "0",
      type: "2",
    })
      .then((res) => {
        // 重置表单
        formData.value = {};
        formRef.value.resetFields();
        selectProductTableRef.value.clearProductData();
        saveIngFlag.value = false;
      })
      .catch((res) => {
        errTableData.value = res.data;
        saveIngFlag.value = false;
      })
      .finally(() => {
        saveIngFlag.value = false;
      });
  });
};

// 重置
const handleReset = () => {
  disabledDelAndAdd.value = false;
  formData.value = {};
  formRef.value.resetFields();
  selectProductTableRef.value.clearProductData();
};

const draftDialogOpen = ref(false);
// 导入草稿
const handleImportDraft = () => {
  draftDialogOpen.value = true;
};
const disabledDelAndAdd = ref(false);
const handleImportDraftSuccess = (data) => {
  formData.value = data;
  const draftList = JSON.parse(data.draft);
  const reData = [];
  if (
    !isNull(draftList) &&
    draftList instanceof Array &&
    draftList.length > 0
  ) {
    draftList.forEach((item) => {
      item.oriIncompleteNumber = item.incompleteNum;
      reData.push({
        ...getProductById(item.productId),
        ...item,
      });
    });
  }
  disabledDelAndAdd.value = true;
  selectProductTableData.value = reData;
};

const importDraftColumns = getCustomTableCols([
  "name",
  "contractNo",
  "batchNo",
  "inWarehouse",
  "operateTime",
  "operatorName",
]);
</script>

<style lang="scss" scoped>
.el-divider--horizontal {
  margin: 15px 0;
}
</style>
